<template>
  <div class="common-footer-container">
    <Row style="height: 100%;">
        <Col :xs="{ span: 0, offset: 0}" :lg="{ span: 7, offset: 5 }">
          <div class="address-list">
            <div class="address-item">
              <div class="title">
                <img src="../../assets/images/logo/location.png" alt="">
                <div>{{$t('address1Name')}}</div>
              </div>
              <div class="address-detail">{{$t('address1Des')}}</div>
            </div>
            <div class="address-item">
              <div class="title">
                <img src="../../assets/images/logo/location.png" alt="">
                <div>{{$t('address2Name')}}</div>
              </div>
              <div class="address-detail">{{$t('address2Des')}}</div>
            </div>
            <div class="address-item">
              <div class="title">
                <img src="../../assets/images/logo/location.png" alt="">
                <div>{{$t('address3Name')}}</div>
              </div>
              <div class="address-detail">{{$t('address3Des')}}</div>
            </div>
          </div>
        </Col>
        <Col :xs="{ span: 24, offset: 0}" :lg="{ span: 0, offset: 0 }">
          <div class="address-list">
            <div class="address-item">
              <div class="title">
                <img src="../../assets/images/logo/location.png" alt="">
                <div>{{$t('companyAddress')}}</div>
              </div>
              <div class="detail-item">
                <div class="label">{{$t('address1Name')}}</div>
                <div>{{$t('address1Des')}}</div>
              </div>
              <div class="detail-item">
                <div class="label">{{$t('address2Name')}}</div>
                <div>{{$t('address2Des')}}</div>
              </div>
              <div class="detail-item">
                <div class="label">{{$t('address3Name')}}</div>
                <div>{{$t('address3Des')}}</div>
              </div>
            </div>
          </div>
        </Col>
        <Col :xs="{ span: 18, offset: 0}" :lg="{ span: 7, offset: 1 }">
          <div class="contact-list">
            <div class="address-item">
              <div class="title">
                <img src="../../assets/images/logo/email.png" alt="" class="email">
                <div>{{$t('contactUs')}}</div>
              </div>
            </div>
            <div class="detail">{{$t('contact1')}}</div>
            <div class="detail">{{$t('contact2')}}</div>
            <div class="detail">{{$t('contact3')}}</div>
          </div>
        </Col>
        <Col :xs="{ span: 6}" :lg="{ span: 4 }">
          <div class="code-container">
            <div class="code-img">
              <img src="../../assets/images/code.jpg" alt="">
            </div>
            <div>{{$t('attention')}}</div>
          </div>
        </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'commonFooter',
  data() {
    return {

    }
  }

}

</script>
<style lang="less">
  .common-footer-container{
    width: 100%;
    min-height: 290px;
    padding: 47px 0;
    background-image: url('../../assets/images/bg1.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    .ivu-col{
      height: 100%;
    }
    .address-list{
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .detail-item{
      display: flex;
      color: #485160;
      font-size: 14px;
      .label{
        color: #8293AD;
        min-width: 70px;
      }
    }
    .contact-list{
      height: 100%;
      .address-item{
        margin-bottom: 26px;
      }
      .detail{
        font-size: 16px;
        color: #485160;
        line-height: 24px;
        margin-bottom: 16px;
      }
    }
    .address-item{
      margin-bottom: 6px;
      .title{
        display: flex;
        align-items: center;
        color:#fff;
        font-size: 18px;
        margin-bottom: 2px;
      }
      img{
        width: 13px;
        height: 17px;
        margin-right: 7px;
      }
      .email{
        width: 18px;
        height: 15px;
      }
      .address-detail{
        font-size: 16px;
        color: #485160;
        line-height: 25px;
      }
    }
    .code-container{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #485160;
      font-size: 16px;
      width: 121px;
      .code-img{
        width: 121px;
        height: 121px;
        background: #A4A4A4;
        // border: 5px solid #FFFFFF;
        box-sizing: border-box;
        margin-bottom: 18px;
        img{
          width: 100%;
          height: 100%; 
        }
      }
    }
    @media screen and (max-width: 992px) {
      .address-list{
        padding: 0 4.5% 47px 4.5%;
        border-bottom: 1px solid rgba(255,255,255, 0.2);
        margin-bottom: 47px;
        box-sizing: border-box;
      }
      .detail-item{
        font-size: 12px;
        margin-bottom: 8px;
        .label{
          min-width: 63px;
        }
      }
      .contact-list{
        padding-left: 4.5%;
         .address-item{
          margin-bottom: 16px;
        }
        .detail{
          font-size: 12px;
          color: #8293AD;
          line-height: 22px;
          margin-bottom: 6px;
        }
      }
      .address-item{
        .title{
          font-size: 14px;
          margin-bottom: .133333rem;
        }
      }
      .code-container{
        width: 1.866667rem;
        font-size: 12px;
        padding-right: 4.5%;
        box-sizing: border-box;
        .code-img{
          width: 1.866667rem;
          height: 1.866667rem;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/footer/index.vue